import { defineEffect } from '../../../core/effect';
import { spec } from '../fx/spsummoning';

/** 状況 `spsummoning_ritual`（組み立ては `../fx/spsummoning.js`。arcade はどの状況も同じ絵） */
export default defineEffect({ situation: 'spsummoning_ritual', role: 'effect', ...spec }, 'spsummoning_ritual_effect.js');
